"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'condition-container';
exports.CHILD = 'condition-container/item';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxxQkFBcUIsQ0FBQztBQUM3QixRQUFBLEtBQUssR0FBRywwQkFBMEIsQ0FBQyJ9